import React, { useState, useEffect } from 'react';

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './Components/Navbar/Navbar';
import Footer from './Components/Footer/Footer';
import HomePage from './Pages/HomePage';
import AboutPage from './Pages/AboutPage';
import ServicesPage from './Pages/ServicesPage';
import ServiceDetail from './Pages/ServiceDetail';
import ContactPage from './Pages/ContactPage';
import hero1 from './Components/Assets/hero1.jpg';
import hero2 from './Components/Assets/hero2.jpg';
import hero3 from './Components/Assets/hero3.jpg';
import hero4 from './Components/Assets/hero4.jpg';

const heroImages = [hero1, hero2, hero3, hero4];

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Preload all carousel images
    let loadedCount = 0;

    heroImages.forEach((image) => {
      const img = new Image();
      img.onload = () => {
        loadedCount++;
        if (loadedCount === heroImages.length) {
          setIsLoading(false);
        }
      };
      img.onerror = () => {
        loadedCount++;
        if (loadedCount === heroImages.length) {
          setIsLoading(false);
        }
      };
      img.src = image;
    });
  }, []);

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: 'white',
        fontFamily: 'inter, sans-serif',
        fontSize: '24px',
        color: '#001945',
        fontWeight: '500'
      }}>
      </div>
    );
  }

  return (
      <div className='app'>
        <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/:serviceIndex" element={<ServiceDetail />} />
          <Route path='/contact' element={<ContactPage />} />
        </Routes>
        <Footer/>
        </BrowserRouter>
      </div>
  );
}

export default App;
